var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"webstated"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.$t('nav.w34')))]),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$t('other.w37'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }